import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import compileErrors from "../compileErorrs"
import { serviceCall, serviceCallPostParms } from "../serviceCall"
import { setLoading } from "../../feature/authSlice"

export const processFileApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCallPostParms({
      url: apiConstants.Invoices.PROCESS_FILE+"?fileId="+data,
      method: 'post',
      // data:data,
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        toast.error(compileErrors(error.response?.data.error))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
